// ecom-backend stores order/transaction timestamps as UTC LocalDateTime (JVM pinned to UTC in its
// Dockerfile) and serializes them without an offset, e.g. "2026-09-28T09:39:23". new Date() would
// read that as browser-local time, so treat an offset-less timestamp as UTC before formatting.
export const parseServerDate = (v) => {
  if (!v) return null;
  if (typeof v !== 'string') return new Date(v);
  return new Date(/[zZ]|[+-]\d{2}:?\d{2}$/.test(v) || !v.includes('T') ? v : `${v}Z`);
};

const IST = 'Asia/Kolkata';

export const fmtIstDateTime = (v, opts) => {
  const d = parseServerDate(v);
  return d ? d.toLocaleString('en-IN', { ...opts, timeZone: IST }) : '—';
};

export const fmtIstDate = (v, opts) => {
  const d = parseServerDate(v);
  return d ? d.toLocaleDateString('en-IN', { ...opts, timeZone: IST }) : '—';
};
